<template>
  <div class="previewOfVoucher">
    <div class="credential-particulars-wrapper">
      <div class="zc_dialog clear">
        <div class="dialog-title">
          <div class="title">{{ voucherType }}</div>
          <div class="date">{{ voucherInfo.date }}</div>
        </div>
        <div class="dialog-table">
          <div class="table-head clear vh-between">
            <span class="f-l">
              <span class="ml-10">{{ voucherInfo.voucherNo }}号</span>
            </span>
            <span class="f-r" v-if="showPage">
              <el-button size="mini" @click="reduceNum" v-show="pageTotalNum"><</el-button>
              <span class="count-sapn">
                <span>{{ activePageNum }}</span>
                <span>/</span>
                <span>{{ pageTotalNum == 0 ? 1 : pageTotalNum }}</span>
              </span>
              <el-button size="mini" @click="plusBtn" v-show="pageTotalNum">></el-button>
            </span>
          </div>
          <div class="tabel-content clear">
            <el-table :data="voucherInfoObj[activePageNum - 1]">
              <el-table-column label="摘要" width="210">
                <template slot-scope="scope">
                  <div v-if="scope.row.flag == false ? true : false">
                    <span class="text" :title="scope.row.abstracts">{{ scope.row.abstracts }}</span>
                  </div>
                  <div v-if="scope.row.flag == false ? false : true">
                    <span class="lookImg">附件单据: &nbsp;{{scope.row.annexCount||0}} 张 &nbsp;&nbsp;</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="科目名称" width="249">
                <template slot-scope="scope">
                  <div v-if="scope.row.flag == false ? true : false" style="text-align:left;">
                    <span
                      class="text"
                      :title="scope.row.accountName || scope.row.subjectName"
                    >{{ scope.row.accountName || scope.row.subjectName }}</span>
                  </div>
                  <div v-if="scope.row.flag == false ? false : true">
                    <span>合计：{{ scope.row.total }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="借方金额">
                <el-table-column prop="yi" label="亿" width="20"></el-table-column>
                <el-table-column prop="qianwan" label="千" width="20"></el-table-column>
                <el-table-column prop="baiwan" label="百" width="20"></el-table-column>
                <el-table-column prop="shiwan" label="十" width="20"></el-table-column>
                <el-table-column prop="wan" label="万" width="20"></el-table-column>
                <el-table-column prop="qian" label="千" width="20"></el-table-column>
                <el-table-column prop="bai" label="百" width="20"></el-table-column>
                <el-table-column prop="shi" label="十" width="20"></el-table-column>
                <el-table-column prop="yuan" label="元" width="20"></el-table-column>
                <el-table-column prop="jiao" label="角" width="20"></el-table-column>
                <el-table-column prop="fen" label="分" width="20"></el-table-column>
              </el-table-column>
              <el-table-column label="贷方金额">
                <el-table-column prop="yi2" label="亿" width="20"></el-table-column>
                <el-table-column prop="qianwan2" label="千" width="20"></el-table-column>
                <el-table-column prop="baiwan2" label="百" width="20"></el-table-column>
                <el-table-column prop="shiwan2" label="十" width="20"></el-table-column>
                <el-table-column prop="wan2" label="万" width="20"></el-table-column>
                <el-table-column prop="qian2" label="千" width="20"></el-table-column>
                <el-table-column prop="bai2" label="百" width="20"></el-table-column>
                <el-table-column prop="shi2" label="十" width="20"></el-table-column>
                <el-table-column prop="yuan2" label="元" width="20"></el-table-column>
                <el-table-column prop="jiao2" label="角" width="20"></el-table-column>
                <el-table-column prop="fen2" label="分" width="20"></el-table-column>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <div class="printMain" v-show="printerDom">
        <div class="Occlusion"></div>
        <div class="printContent zc_dialog" id="credentialTable">
          <div class="item RenderingDiv" v-for="(item, index) in voucherInfoObj" :key="index">
            <div class="dialog-title">
              <div class="title">{{ voucherType }}</div>
              <div class="date">{{ voucherInfo.date }}</div>
            </div>
            <div class="dialog-table">
              <div class="table-head clear">
                <!-- 核算单位： -->
                <span class="f-l">
                  <span class="ml-10">{{ voucherInfo.voucherId }}号</span>
                </span>
                <!-- <span class="f-r">第{{voucherInfo.voucherId}}号——000{{index+1}}/000{{pageTotalNum}}</span> -->
              </div>
              <div class="tabel-content clear">
                <el-table :data="item">
                  <el-table-column label="摘要" width="210">
                    <template slot-scope="scope">
                      <div v-if="scope.row.flag == false ? true : false">
                        <span class="text" :title="scope.row.abstracts">
                          {{
                          scope.row.abstracts
                          }}
                        </span>
                      </div>
                      <div v-if="scope.row.flag == false ? false : true">
                        <span class="lookImg">附件单据: &nbsp;{{scope.row.annexCount||0}} 张 &nbsp;&nbsp;</span>
                        <!-- <span>附单据数: &nbsp;{{voucherInfo.billNum}}张 &nbsp;&nbsp;</span> -->
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="科目名称" width="249">
                    <template slot-scope="scope">
                      <div v-if="scope.row.flag == false ? true : false">
                        <span class="text" :title="scope.row.accountName">
                          {{
                          scope.row.accountName
                          }}
                        </span>
                      </div>
                      <div v-if="scope.row.flag == false ? false : true">
                        <span>合计：{{ scope.row.total }}</span>
                      </div>
                     
                    </template>
                  </el-table-column>
                  <el-table-column label="借方金额" width="232">
                    <el-table-column prop="yi" label="亿" width="20"></el-table-column>
                    <el-table-column prop="qianwan" label="千" width="20"></el-table-column>
                    <el-table-column prop="baiwan" label="百" width="20"></el-table-column>
                    <el-table-column prop="shiwan" label="十" width="20"></el-table-column>
                    <el-table-column prop="wan" label="万" width="20"></el-table-column>
                    <el-table-column prop="qian" label="千" width="20"></el-table-column>
                    <el-table-column prop="bai" label="百" width="20"></el-table-column>
                    <el-table-column prop="shi" label="十" width="20"></el-table-column>
                    <el-table-column prop="yuan" label="元" width="20"></el-table-column>
                    <el-table-column prop="jiao" label="角" width="20"></el-table-column>
                    <el-table-column prop="fen" label="分" width="20"></el-table-column>
                  </el-table-column>
                  <el-table-column label="贷方金额" width="250">
                    <el-table-column prop="yi2" label="亿" width="20"></el-table-column>
                    <el-table-column prop="qianwan2" label="千" width="20"></el-table-column>
                    <el-table-column prop="baiwan2" label="百" width="20"></el-table-column>
                    <el-table-column prop="shiwan2" label="十" width="20"></el-table-column>
                    <el-table-column prop="wan2" label="万" width="20"></el-table-column>
                    <el-table-column prop="qian2" label="千" width="20"></el-table-column>
                    <el-table-column prop="bai2" label="百" width="20"></el-table-column>
                    <el-table-column prop="shi2" label="十" width="20"></el-table-column>
                    <el-table-column prop="yuan2" label="元" width="20"></el-table-column>
                    <el-table-column prop="jiao2" label="角" width="20"></el-table-column>
                    <el-table-column prop="fen2" label="分" width="20"></el-table-column>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { mapGetters } from 'vuex'
import html2canvas from "html2canvas";
export default {
  name: "previewOfVoucher",
  data () {
    return {
      userName: "张三",
      credentialData: [],

      voucherInfo: {
        date: "",
        voucherNo: ""
      }, //存储查看凭证的原始数据
      copyVoucherInfo: {}, //存储处理后的渲染数据
      voucherInfoObj: [[]], //保存凭证table渲染列表
      pageTotalNum: 1, // 切换总页码
      activePageNum: 1, //当前页码
      PastTimes: "2018-10-09",
      id: this.$route.query.type,
      date: this.$route.query.date,
      pageType: this.$route.query.pageType,
      voucherType: "记账凭证",
      visible2: false,

      item: {},
      oaProjectBillingInvoices: [],
      activePageNum2: 1,
      pageTotalNum2: 1,
      isShowTips: false,
      MachineBeating: false,
      isShowInvoiceByMachine: true, // 是否显示机打发票
      isShowOtherInvoices: true, // 是否显示其他发票
      InvoicesTipsWidth: 0,
      saveCompanyName: "",
      printerDom: false //打印
    };
  },
  props: {
    list: null,
    showPage: {
      type: Boolean,
      default: true
    }
  },
  created () {
    //this.accountingId = this.invokerObj.id;
    //this.saveCompanyName = this.invokerObj.customer;

    this.generateCredentials(this.list);
  },
  watch: {
    list (newObj, oldObj) {
      this.generateCredentials(newObj);
    },
    $route (newUrl, oldUrl) {
      if (newUrl.name == "voucherMake/previewOfVoucher") {
        this.date = newUrl.query.date;
        this.id = newUrl.query.type;
        this.pageType = newUrl.query.pageType;
        this.generateCredentials(this.list);
      }
    }
  },
  methods: {
    printer () {
      this.printerDom = true;
      this.$nextTick(() => {
        var self = this;
        let content_html = document.getElementById("credentialTable"); //要转化的div
        let width = content_html.offsetWidth;
        let height = content_html.offsetHeight;
        let offsetTop = content_html.offsetTop;
        let canvas = document.createElement("canvas");
        let context = canvas.getContext("2d");
        let scaleBy = Math.ceil(window.devicePixelRatio);
        canvas.width = width * scaleBy;
        canvas.height = (height + offsetTop) * scaleBy;
        context.scale(1, 1);
        var opts = {
          allowTaint: true, //允许加载跨域的图片
          tainttest: true, //检测每张图片都已经加载完成
          scale: scaleBy, // 添加的scale 参数
          canvas: canvas, //自定义 canvas
          logging: false, //日志开关，发布的时候记得改成false
          width: width, //dom 原始宽度
          height: height //dom 原始高度
        };
        html2canvas(content_html, opts).then(function (canvas) {
          canvas.style.width = width + "px";
          canvas.style.height = height + "px";
          var image = new Image();
          var imgUri = canvas
            .toDataURL("image/jpeg")
            .replace("image/jpeg", "image/octet-stream"); // 获取生成的图片的url
          self.print(imgUri);
        });
      });
    },
    print (baseUrl) {
      let img = document.createElement("img");
      img.src = baseUrl;
      img.style.display = "block";
      img.style.width = "100%";
      let newDiv = document.createElement("div");
      newDiv.style.display = "block";
      newDiv.style.width = "1300px";
      newDiv.style.height = "900px";
      newDiv.appendChild(img);
      setTimeout(() => {
        var newStr = newDiv.innerHTML;
        var oldStr = document.body.innerHTML;
        document.body.innerHTML = newStr;
        window.print();
        window.location.reload();
        document.body.innerHTML = oldStr;
      }, 500);
    },
    reduceNum () {
      //上一页
      if (this.activePageNum == 1) {
        return;
      }
      this.activePageNum--;
    },
    plusBtn () {
      //下一页
      if (this.activePageNum == this.pageTotalNum || this.pageTotalNum == 0) {
        return;
      }
      this.activePageNum++;
    },
    generateCredentials (res) {
      //渲染生成凭证
      if (!res) {
        return;
      }
      // this.oaProjectBillingInvoices = res.data.machineInvoiceArray;
      // this.item = res.data.machineInvoiceArray[0];
      // this.pageTotalNum2 = res.data.machineInvoiceArray.length;
      this.voucherInfoObj = [];

      // res.pzVoucherRowList.forEach((item, index) => {
      // // 后期加上
      // this.images.push('https://www.mashangji.cn/um/' + item.annexUrl);
      // });
      // this.pageTotalNum2 ==  0 ? this.isShowInvoiceByMachine = false  : this.isShowInvoiceByMachine = true
      // this.images.length ==  0 ? this.isShowOtherInvoices = false  : this.isShowOtherInvoices = true


      var self = this,
        num = 1,
        pzVoucherList = [];
      //银行流水
      if (JSON.stringify(res)!='{}') {
        // this.voucherInfo.data = res[0].date;
        // this.voucherInfo.voucherNo = res[0].voucherNo;
        // pzVoucherList = res[0].pzVoucherRowList;
        this.voucherInfo.date = res.date;
        this.voucherInfo.voucherNo = res.voucherNo;
        pzVoucherList = res.pzVoucherRowList;
        num = 1;
      } else {
        this.voucherInfo = res; //为了保存原始数据
        var info = JSON.parse(JSON.stringify(res)); //为了更改数据。
        pzVoucherList = info.pzVoucherRowList || [];
        num = Math.ceil(pzVoucherList.length / 5);
      }
      this.pageTotalNum = num;
      pzVoucherList.forEach((item, index) => {
        item.flag = false;
        if (item.type == "debit") {
          if (item.money == "0.00") {
            item.money = "";
          }
          item.money = item.money.replace(".", "");
          item.fen = item.money.charAt(item.money.length - 1);
          item.jiao = item.money.charAt(item.money.length - 2);
          item.yuan = item.money.charAt(item.money.length - 3);
          item.shi = item.money.charAt(item.money.length - 4);
          item.bai = item.money.charAt(item.money.length - 5);
          item.qian = item.money.charAt(item.money.length - 6);
          item.wan = item.money.charAt(item.money.length - 7);
          item.shiwan = item.money.charAt(item.money.length - 8);
          item.baiwan = item.money.charAt(item.money.length - 9);
          item.qianwan = item.money.charAt(item.money.length - 10);
          item.yi = item.money.charAt(item.money.length - 11);
        } else if (item.type == "lender") {
          if (item.money == "0.00") {
            item.money = "";
          }
          item.money = item.money.replace(".", "");
          item.fen2 = item.money.charAt(item.money.length - 1);
          item.jiao2 = item.money.charAt(item.money.length - 2);
          item.yuan2 = item.money.charAt(item.money.length - 3);
          item.shi2 = item.money.charAt(item.money.length - 4);
          item.bai2 = item.money.charAt(item.money.length - 5);
          item.qian2 = item.money.charAt(item.money.length - 6);
          item.wan2 = item.money.charAt(item.money.length - 7);
          item.shiwan2 = item.money.charAt(item.money.length - 8);
          item.baiwan2 = item.money.charAt(item.money.length - 9);
          item.qianwan2 = item.money.charAt(item.money.length - 10);
          item.yi = item.money.charAt(item.money.length - 11);
        }
      });
      if (num == 1) {
        let totalMoeny1 = 0;
        let totalMoeny2 = 0;
        pzVoucherList.forEach((item, index) => {
          if (item.type == "debit") {
            totalMoeny1 += item.money - 0;
          } else if (item.type == "lender") {
            totalMoeny2 += item.money - 0;
          }
        });
        totalMoeny1 = totalMoeny1 + "";
        totalMoeny2 = totalMoeny2 + "";
        totalMoeny1 ? totalMoeny1 : "";
        totalMoeny2 ? totalMoeny2 : "";
        let flagArr = [...pzVoucherList];
        let flagNum = 5 - flagArr.length;
        let obj = {
          abstracts: "",
          accountName: "",
          money: "",
          type: "",
          flag: false
        };
        for (let i = 0; i < flagNum; i++) {
          flagArr.push(obj);
        }

        let obj2 = {
          abstracts: "",
          accountName: "",
          money: "",
          type: "",
          flag: true,
          fen: totalMoeny1.charAt(totalMoeny1.length - 1),
          jiao: totalMoeny1.charAt(totalMoeny1.length - 2),
          yuan: totalMoeny1.charAt(totalMoeny1.length - 3),
          shi: totalMoeny1.charAt(totalMoeny1.length - 4),
          bai: totalMoeny1.charAt(totalMoeny1.length - 5),
          qian: totalMoeny1.charAt(totalMoeny1.length - 6),
          wan: totalMoeny1.charAt(totalMoeny1.length - 7),
          shiwan: totalMoeny1.charAt(totalMoeny1.length - 8),
          baiwan: totalMoeny1.charAt(totalMoeny1.length - 9),
          qianwan: totalMoeny1.charAt(totalMoeny1.length - 10),
          yi: totalMoeny1.charAt(totalMoeny1.length - 11),
          fen2: totalMoeny2.charAt(totalMoeny2.length - 1),
          jiao2: totalMoeny2.charAt(totalMoeny2.length - 2),
          yuan2: totalMoeny2.charAt(totalMoeny2.length - 3),
          shi2: totalMoeny2.charAt(totalMoeny2.length - 4),
          bai2: totalMoeny2.charAt(totalMoeny2.length - 5),
          qian2: totalMoeny2.charAt(totalMoeny2.length - 6),
          wan2: totalMoeny2.charAt(totalMoeny2.length - 7),
          shiwan2: totalMoeny2.charAt(totalMoeny2.length - 8),
          baiwan2: totalMoeny2.charAt(totalMoeny2.length - 9),
          qianwan2: totalMoeny2.charAt(totalMoeny2.length - 10),
          yi2: totalMoeny2.charAt(totalMoeny2.length - 11),
          total: this.$toCapitalizationAmount(totalMoeny1 / 100),
          annexCount:res.annexCount
        };
        flagArr.push(obj2);
        this.voucherInfoObj.push(flagArr);
      } else {
        for (let i = 0; i < num - 1; i++) {
          let arr = [];
          let totalMoeny1 = 0;
          let totalMoeny2 = 0;
          arr = pzVoucherList.splice(0, 5);
          arr.forEach((item, index) => {
            if (item.type == "debit") {
              totalMoeny1 += item.money - 0;
            } else if (item.type == "lender") {
              totalMoeny2 += item.money - 0;
            }
          });
          totalMoeny1 = totalMoeny1 + "";
          totalMoeny2 = totalMoeny2 + "";
          totalMoeny1 ? totalMoeny1 : "";
          totalMoeny2 ? totalMoeny2 : "";
          let obj2 = {
            abstracts: "",
            accountName: "",
            money: "",
            type: "",
            flag: true,
            annexCount:res.annexCount,//
          };
          arr.push(obj2);
          this.voucherInfoObj.push(arr);
        }

        let lastArr = [...pzVoucherList];
        let flagNum = 5 - lastArr.length;
        let obj = {
          abstracts: "",
          accountName: "",
          money: "",
          type: "",
          flag: false
        };
        for (let i = 0; i < flagNum; i++) {
          lastArr.push(obj);
        }

        var totalMoeny3 = 0;
        var totalMoeny4 = 0;
        pzVoucherList.forEach((item, index) => {
          if (item.type == "debit") {
            totalMoeny3 += item.money.replace(".", "") - 0;
          } else if (item.type == "lender") {
            totalMoeny4 += item.money.replace(".", "") - 0;
          }
        });
        totalMoeny3 = totalMoeny3 + "";
        totalMoeny4 = totalMoeny4 + "";
        totalMoeny3 ? totalMoeny3 : "";
        totalMoeny4 ? totalMoeny4 : "";
        let obj3 = {
          abstracts: "",
          accountName: "",
          money: "",
          type: "",
          flag: true,
          fen: totalMoeny3.charAt(totalMoeny3.length - 1),
          jiao: totalMoeny3.charAt(totalMoeny3.length - 2),
          yuan: totalMoeny3.charAt(totalMoeny3.length - 3),
          shi: totalMoeny3.charAt(totalMoeny3.length - 4),
          bai: totalMoeny3.charAt(totalMoeny3.length - 5),
          qian: totalMoeny3.charAt(totalMoeny3.length - 6),
          wan: totalMoeny3.charAt(totalMoeny3.length - 7),
          shiwan: totalMoeny3.charAt(totalMoeny3.length - 8),
          baiwan: totalMoeny3.charAt(totalMoeny3.length - 9),
          qianwan: totalMoeny3.charAt(totalMoeny3.length - 10),
          yi: totalMoeny3.charAt(totalMoeny3.length - 11),
          fen2: totalMoeny4.charAt(totalMoeny4.length - 1),
          jiao2: totalMoeny4.charAt(totalMoeny4.length - 2),
          yuan2: totalMoeny4.charAt(totalMoeny4.length - 3),
          shi2: totalMoeny4.charAt(totalMoeny4.length - 4),
          bai2: totalMoeny4.charAt(totalMoeny4.length - 5),
          qian2: totalMoeny4.charAt(totalMoeny4.length - 6),
          wan2: totalMoeny4.charAt(totalMoeny4.length - 7),
          shiwan2: totalMoeny4.charAt(totalMoeny4.length - 8),
          baiwan2: totalMoeny4.charAt(totalMoeny4.length - 9),
          qianwan2: totalMoeny4.charAt(totalMoeny4.length - 10),
          yi2: totalMoeny4.charAt(totalMoeny4.length - 11),
          total: this.$toCapitalizationAmount(totalMoeny3 / 100)
        };
        lastArr.push(obj3);
        this.voucherInfoObj.push(lastArr);
      
      }
    },
  }
};
</script>
<style scoped lang="scss">
// @import url("./main.scss");
.previewOfVoucher {
  position: relative;

.clearfix::after {
  content: "";
  height: 0;
  line-height: 0;
  display: block;
  visibility: hidden;
  clear: both;
}
.clearfix {
  zoom: 1;
}
.tips_content_top {
  padding: 0px 60px 0px 50px;
  .tipsTitle {
    float: left;
    line-height: 50px;
    font-size: 14px;
  }
  .tipsPage {
    float: right;
    line-height: 50px;
  }
}
.tips {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1000;
  .tips_content {
    width: 1000px;
    height: 600px;
    overflow: auto;
    background-color: #fff;
    position: absolute;
    left: 50%;
    top: 30%;
    margin-top: -150px;
    margin-left: -500px;
  }
}
.credential-particulars-wrapper {
  width: 100%;
  height: 100%;
  //background-color: #f2f2f2;
  // overflow: hidden;
}
.zc_dialog {
  //width: 960px;
  background-color: #fff;
  padding: 30px 0;
  //margin: 50px auto;
  //padding-bottom: 20px;
  .dialog-title {
    width: 220px;
    margin: 0 auto;
    .title {
      width: 220px;
      height: 50px;
      line-height: 50px;
      font-family: "PingFangSC,微软雅黑";
      font-size: 36px;
      color: #274253;
      letter-spacing: 0.4em;
      text-indent: 0.4em;
      border-bottom: 2px solid #274253;
    }
    .title + div {
      border-top: solid 1px #274253;
      margin-top: 5px;
      padding-top: 5px;
    }
    .date {
      text-align: center;
      height: 40px;
      line-height: 40px;
    }
  }
  .dialog-table {
    width: 900px;
    min-height: 255px;
    margin: 0px auto;
    .table-head {
      margin: 5px 0;
      font-family: "PingFangSC,微软雅黑";
      font-size: 13px;
      color: #274253;
      letter-spacing: 0;
      line-height: 28px;
      .count-sapn {
        padding: 0 12px;
      }
    }
    .lookImg {
      margin-right: 36px;
    }
  }
  .dialog-imgs {
    margin-top: 20px;
    line-height: 55px;
    text-align: left;
    padding: 0 20px;
    display: flex;
    > div.el-image {
      margin-left: 20px;
    }
  }
}

.item {
  border-bottom: dashed 1px #d8d8d8;
  margin-bottom: 5px;
  &:nth-child(3n + 0) {
    border-bottom: none;
  }
  &:last-child {
    border-bottom: none;
  }
}
.printMain {
  background-color: #274253;
  position: relative;
  .Occlusion {
    width: 100%;
    height: 100%;
    background-color: #f2f2f2;
    position: absolute;
    z-index: 999;
  }
}
.text {
  font-size: 11px;
  white-space: pre-wrap;
  word-break: break-all;
}
.show {
  display: inline-block;
  margin-right: 20px;
  font-size: 14px;
  &:hover {
    color: rgb(59, 164, 236);
    cursor: pointer;
  }
}

.content_container_wrapper {
  position: relative;
  .el-button + .el-button {
    margin-left: 0;
  }
  .ml-52 {
    margin-left: 52px;
  }
  .triangle {
    width: 0;
    height: 0;
    border-width: 0 25px 15px;
    border-style: solid;
    border-color: transparent transparent #fafafa;
    position: absolute;
    margin-left: 67%;
    margin-top: -5px;
  }
  .dashed {
    width: 86%;
    margin-left: 7%;
  }
  .content_container {
    width: 90%;
    margin-left: 4%;
    background: #fafafa;
    padding: 10px 15px;
    margin-bottom: 10px;
    box-shadow: 0 5px 7px 0 rgba(231, 231, 231, 0.5);
    .invoice_wrapper {
      width: 100%;
      border: 1px solid #83cace;
      .box1 {
        font-size: 13px;
        color: #28aab2;
        border-right: 1px solid #28aab2;
        text-align: center;
        height: 160px;
      }
      .box2 {
        height: 160px;
        border-right: 1px solid #28aab2;
        padding-left: 20px;
        overflow-y: auto;
      }
      .box3 {
        font-size: 13px;
        color: #647987;
        height: 160px;
        padding: 10px 20px;
      }
      .table_list {
        border-top: 1px solid #28aab2;
      }
      .box4 {
        border-top: 1px solid #28aab2;
        border-bottom: 1px solid #28aab2;
        background: #ecf7f7;
      }
      .textarea-info {
        font-size: 13px;
      }
    }
    .general_success_icon {
      color: #7b868d;
      margin-left: 8%;
      margin-bottom: 10px;
      .el-icon-success:before {
        font-size: 16px;
        margin-right: 10px;
        color: #83d13a;
      }
    }
  }
}

.RenderingDiv {
  margin-bottom: 50px;
}
.iconfontTwo {
  position: absolute;
  top: 50%;
  cursor: pointer;
}
.lastStep {
  left: 0;
}
.nextStep {
  right: 0;
  transform: rotate(180deg);
}

}
</style>
